import Joi from 'joi-browser';

const validationSchema = {
  name: Joi.string()
    .label('Nombre')
    .max(255)
    .required(),
  country: Joi.string()
    .label('País')
    .required(),
  website: Joi.string()
    .label('Sitio Web')
    .uri({
      scheme: ['http', 'https'],
    })
    .required(),
  plan: Joi.string()
    .label('Plan')
    .required(),
  address: Joi.string()
    .label('Dirección')
    .required(),
  city: Joi.string()
    .label('Ciudad')
    .required(),
  biography: Joi.string()
    .label('Biografía')
    .required(),
  capacity: Joi.string()
    .label('Número de butacas')
    .required(),
  facebook: Joi.string()
    .label('Facebook'),
  director: Joi.string()
    .label('Director ejecutivo'),
  contact: Joi.string()
    .label('Nombre del contacto'),
  email: Joi.string()
    .label('Correo electrónico'),
  telephone: Joi.string()
    .label('Teléfono'),
  role: Joi.string()
    .label('Rol'),
  type: Joi.string()
    .label('Tipo de institución'),
  enabledStats: Joi.boolean(),
  files: Joi.array()
    .label('Archivos')
    .max(8)
    .required()
    .error(() => [
      {
        type: 'any.required',
        message: 'Debes subir al menos un archivo PDF de documentos técnicos',
      },
    ]),
  images: Joi.array()
    .label('Imágenes')
    .max(8)
    .min(1)
    .error(() => ({
      type: 'array.min',
      message: 'Debes subir al menos una imagen para este teatro',
    })),
};


export default validationSchema;



// WEBPACK FOOTER //
// ./src/containers/Admin/Theater/Form/validation.js